import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ChartCategory } from 'src/app/common/service';
import { AbinResultDto } from 'src/app/inge-api/abinclient/models';
import { FordelningPiechartBaseComponent } from '../../base-components';
@Component({
    selector: 'app-foder-produktiv-skogsmark-chart',
    templateUrl: './foder-produktiv-skogsmark-chart.component.html',
    styleUrls: ['./foder-produktiv-skogsmark-chart.component.scss']
})
export class FoderProduktivSkogsmarkChartComponent extends FordelningPiechartBaseComponent implements OnInit, OnDestroy {
    private subs: Subscription[];
    private chartEntries = [
        {
            name: 'Tallskog',
            key: 'tallAldreskogHaRT',
            color: ChartCategory.TALL
        },
        {
            name: 'Granskog',
            key: 'granAldreskogHaRT',
            color: ChartCategory.GRAN
        },
        {
            name: 'Barrblandskog',
            key: 'barrblandAldreskogHaRT',
            color: ChartCategory.BARRBLAND
        },
        {
            name: 'Övrig skog',
            key: 'ovrigtAldreskogHaRT',
            color: ChartCategory.OVRIG
        }
    ];
    inventeringsAr: number;
    data: any[][];
    legendData: any[];
    ngOnInit(): void {
        this.subs = [];
        this.subs.push(
            this.inventering$.subscribe((x) => {
                if (x) {
                    this.generateChartData(x);
                }
            })
        );
    }

    generateChartData(senasteInventering: AbinResultDto) {
        const data: any[][] = [['Träslag', 'Procent']];
        const colors = [];
        const legendData = [];
        this.inventeringsAr = senasteInventering.invAr;
        const total = this.getTotalSkogHaRT(senasteInventering);
        for (const entry of this.chartEntries) {
            if (senasteInventering[entry.key]) {
                const name = entry.name;
                const value = Math.round((senasteInventering[entry.key] / total) * 100);
                const color = this.colormapService.getColor(entry.color);
                data.push([name, value]);
                colors.push(color);
                legendData.push({ name, value, color });
            }
        }
        this.data = data;
        this.options = { ...this.options, colors };
        this.legendData = legendData;
    }

    getTotalSkogHaRT(inv: AbinResultDto): number {
        return Math.round((inv.barrblandAldreskogHaRT || 0) + (inv.granAldreskogHaRT || 0) + (inv.ovrigtAldreskogHaRT || 0) + (inv.tallAldreskogHaRT || 0));
    }

    ngOnDestroy(): void {
        this.subs.forEach((x) => x.unsubscribe());
    }
}
